// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__2k6o9"};